import React, { Component } from "react";
import { getStatistics } from "../api/stats";
import Loading from "./Loading";

export default class Statistics extends Component {
  constructor(props) {
    super(props);

    this.state = {
      stats: undefined,
    };
  }

  componentDidMount() {
    getStatistics().then((res) => {
      this.setState({ stats: res });
    });
  }

  render() {
    if (!this.state.stats) {
      return (
        <div className="is-flex is-justify-content-center mt-6 ">
          <Loading />
        </div>
      );
    }

    const stats = this.state.stats;

    return (
      <div className="section mx-6">
        <section className="section ">
          <div className="container sie-title-container">
            <h4 className="title">Statistics</h4>
            <h5 className="subtitle">Statistics about the tool usage</h5>
          </div>
        </section>

        {/* Notifications  */}
        <section className="section ">
          <div className="container">
            <label className="label">Notifications Created</label>
            <table className="table is-striped is-fullwidth">
              <thead>
                <tr>
                  <th>Time Frame</th>
                  <th style={{ width: "20rem" }}>Count</th>
                </tr>
              </thead>

              <tbody>
                <tr key="lastDay">
                  <th>Last Day</th>
                  <th>{stats.notificationCountLastDay}</th>
                </tr>
                <tr key="lastMonth">
                  <th>Last Month</th>
                  <th>{stats.notificationCountLastMonth}</th>
                </tr>
                <tr key="total">
                  <th>Total</th>
                  <th>{stats.notificationCountTotal}</th>
                </tr>
              </tbody>
            </table>
          </div>

          {/* SMS COUNTS */}
          <div className="container mt-5">
            <label className="label">SMS Sent</label>
            <table className="table is-striped is-fullwidth">
              <thead>
                <tr>
                  <th>Time Frame</th>
                  <th style={{ width: "20rem" }}>Count</th>
                </tr>
              </thead>

              <tbody>
                <tr key="lastDay">
                  <th>Last Day</th>
                  <th>{stats.smsCountLastDay}</th>
                </tr>
                <tr key="lastMonth">
                  <th>Last Month</th>
                  <th>{stats.smsCountLastMonth}</th>
                </tr>
                <tr key="total">
                  <th>Total</th>
                  <th>{stats.smsCountTotal}</th>
                </tr>
              </tbody>
            </table>
          </div>

          {/* SMS COUNTS */}
          <div className="container mt-5">
            <label className="label">SMS Sent By Type</label>
            <table className="table is-striped is-fullwidth">
              <thead>
                <tr>
                  <th>Type</th>
                  <th style={{ width: "20rem" }}>Count</th>
                </tr>
              </thead>

              <tbody>
                <tr key="notification">
                  <th>Notification</th>
                  <th>
                    {stats.outboundTypeStats.find(
                      (ots) => ots["recordType"] === "NOTIFICATION"
                    )
                      ? stats.outboundTypeStats.find(
                          (ots) => ots["recordType"] === "NOTIFICATION"
                        ).count
                      : 0}
                  </th>
                </tr>
                <tr key="warning">
                  <th>Invalid Response Warning</th>
                  <th>
                    {stats.outboundTypeStats.find(
                      (ots) => ots["recordType"] === "WRONG_ANSWER"
                    )
                      ? stats.outboundTypeStats.find(
                          (ots) => ots["recordType"] === "WRONG_ANSWER"
                        ).count
                      : 0}
                  </th>
                </tr>
                <tr key="reminder">
                  <th>Reminder To Answer (Exceeded Response Deadline)</th>
                  <th>
                    {stats.outboundTypeStats.find(
                      (ots) => ots["recordType"] === "REMINDER"
                    )
                      ? stats.outboundTypeStats.find(
                          (ots) => ots["recordType"] === "REMINDER"
                        ).count
                      : 0}
                  </th>
                </tr>
              </tbody>
            </table>
          </div>

          {/* SPENDING */}
          <div className="container mt-5">
            <label className="label">Spending Quotas</label>
            <table className="table is-striped is-fullwidth">
              <thead>
                <tr>
                  <th>Item</th>
                  <th style={{ width: "20rem" }}>Value</th>
                </tr>
              </thead>

              <tbody>
                <tr key="remaining_quote">
                  <th>Monthly Remaining Quota</th>
                  <th>
                    $ {stats.remainingSpending.toFixed(2)} (
                    {(
                      (stats.remainingSpending / stats.costLimit) *
                      100
                    ).toFixed(2)}
                    %)
                  </th>
                </tr>
                <tr key="monthly_spending">
                  <th>Monthly Spent Quota</th>
                  <th>
                    $ {stats.monthlySpendingEstimate.toFixed(2)} (
                    {(
                      (stats.monthlySpendingEstimate / stats.costLimit) *
                      100
                    ).toFixed(2)}
                    %)
                  </th>
                </tr>
                <tr key="spending_limit">
                  <th>Spending Limit</th>
                  <th>$ {stats.costLimit.toFixed(2)}</th>
                </tr>
              </tbody>
            </table>
          </div>
        </section>
      </div>
    );
  }
}
